export class UpdateBuyerData {
  addressType: string = "";
  addressFirst: string;
  addressSecond: string;
  addressThird: string;
  addressOther: string;
  city: string = "";
  cellphone1: string;
  email1: string;
  cellphone2?: string;
  email2?: string;
  modeWP: boolean;
  modeEmail: boolean;
  modeSMS: boolean;
  modePhone: boolean;
  expeditionDate: string;

  public static toRequest(
    updateBuyerDataForm: UpdateBuyerData
  ): any {
    return {
      canal_whatsapp: updateBuyerDataForm.modeWP ? 'S' : 'N',
      canal_correo: updateBuyerDataForm.modeEmail ? 'S' : 'N',
      canal_sms: updateBuyerDataForm.modeSMS ? 'S' : 'N',
      canal_llamada: updateBuyerDataForm.modePhone ? 'S' : 'N',
    };
  }
}

export class UpdateBuyerAdditionalData {
  //Representante Legal
  legalRepresentativeNames: string;
  legalRepresentativeLastNames: string;
  legalRepresentativeDocumentType: string;
  legalRepresentativeDocumentNumber: string;
  legalRepresentativeEmail: string;
  legalRepresentativeCellphone: string;

  //Contacto
  contactNames: string;
  contactLastNames: string;
  contactEmail: string;
  contactCellphone: string;
  contactPosition: string;

  public static toRequest(
    buyerAdditionalData: UpdateBuyerAdditionalData
  ): any {
    return {
      nombres_rep: buyerAdditionalData.legalRepresentativeNames,
      apel1_rep: buyerAdditionalData.legalRepresentativeLastNames,
      tipo_doc_rep: buyerAdditionalData.legalRepresentativeDocumentType,
      doc_rep: buyerAdditionalData.legalRepresentativeDocumentNumber,
      correo: buyerAdditionalData.legalRepresentativeEmail,
      celular: buyerAdditionalData.legalRepresentativeCellphone,

      nom1_contacto: buyerAdditionalData.contactNames,
      apel1_contacto: buyerAdditionalData.contactLastNames,
      correo_contacto: buyerAdditionalData.contactEmail,
      cel_contacto: buyerAdditionalData.contactCellphone,
      cargo_contacto: buyerAdditionalData.contactPosition,
    };
  }
}